import { SelectContent, SelectItem } from '@/components/ui/select'

export interface TTSVoice {
  value: string
  label: string
  lang: 'fr' | 'en' | 'es' | 'multi'
}

/** Voix TTS Google Cloud + voix basiques Twilio — port 1:1 Next. */
export const TTS_VOICES: TTSVoice[] = [
  // 🇨🇦 Français Canada
  { value: 'Google.fr-CA-Neural2-A', label: '🇨🇦 Micheline (Français Canada, Féminine) ⭐', lang: 'fr' },
  { value: 'Google.fr-CA-Neural2-B', label: '🇨🇦 Mathieu (Français Canada, Masculin) ⭐', lang: 'fr' },
  // 🇫🇷 Français France
  { value: 'Google.fr-FR-Neural2-A', label: '🇫🇷 Suzanne (Français France, Féminine)', lang: 'fr' },
  { value: 'Google.fr-FR-Neural2-B', label: '🇫🇷 Louis (Français France, Masculin)', lang: 'fr' },
  // 🇺🇸 Anglais US
  { value: 'Google.en-US-Neural2-C', label: '🇺🇸 Emma (Anglais US, Féminine)', lang: 'en' },
  { value: 'Google.en-US-Neural2-D', label: '🇺🇸 Jackson (Anglais US, Masculin)', lang: 'en' },
  // 🇬🇧 Anglais UK
  { value: 'Google.en-GB-Neural2-A', label: '🇬🇧 Charlotte (Anglais UK, Féminine)', lang: 'en' },
  { value: 'Google.en-GB-Neural2-B', label: '🇬🇧 Oliver (Anglais UK, Masculin)', lang: 'en' },
  // 🇪🇸 Espagnol Espagne
  { value: 'Google.es-ES-Neural2-A', label: '🇪🇸 María (Espagnol Espagne, Féminine)', lang: 'es' },
  { value: 'Google.es-ES-Neural2-B', label: '🇪🇸 Carlos (Espagnol Espagne, Masculin)', lang: 'es' },
  // 🇲🇽 Espagnol Mexique
  { value: 'Google.es-MX-Neural2-A', label: '🇲🇽 Guadalupe (Espagnol Mexique, Féminine)', lang: 'es' },
  { value: 'Google.es-MX-Neural2-B', label: '🇲🇽 Diego (Espagnol Mexique, Masculin)', lang: 'es' },
]

/** Anciennes voix Twilio, de moins bonne qualité : plus proposées, mais toujours lues
 *  sur les nœuds qui les utilisent déjà. */
const VOIX_BASIQUES: TTSVoice[] = [
  { value: 'alice', label: '🌐 Alice (Basique - Anglais)', lang: 'en' },
  { value: 'man', label: '🌐 Man (Basique - Multilingue)', lang: 'multi' },
  { value: 'woman', label: '🌐 Woman (Basique - Multilingue)', lang: 'multi' },
]

/** `actuelle` : la voix du nœud ; une voix basique déjà choisie reste affichée. */
export function VoiceSelectContent({ actuelle }: { actuelle?: string }) {
  const ancienne = VOIX_BASIQUES.find((v) => v.value === actuelle)
  return (
    <SelectContent className="max-h-80">
      {[...TTS_VOICES, ...(ancienne ? [ancienne] : [])].map((voice) => (
        <SelectItem key={voice.value} value={voice.value}>
          {voice.label}
        </SelectItem>
      ))}
    </SelectContent>
  )
}
